<template>
  <div class="line-page">
    <navbarBox></navbarBox>
    <linetoken></linetoken>
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import linetoken from "../components/linetoken";
export default {
  name: "line",
  components: { navbarBox, linetoken },
};
</script>

<style>
.line-page {
  height: 100%;
}
</style>